
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { MaterialModule } from '../../shared/material.module';
import { ActionPopupComponent } from './action-popup/action-popup-inInventory/action-popup.component';
import { ActionService } from './action.service.service';
import { RecordActionComponent } from './record-action/record-action.component';
import { SystemActionsComponent } from './record-action/system-actions/system-actions.component';
import { SystemActionViewComponent } from './record-action/system-action-view/system-action-view.component';
import { ComponentActionViewComponent } from './record-action/component-action-view/component-action-view.component';
import { CreateMultipleSystemComponentsComponent } from './record-action/create-multiple-system-components/create-multiple-system-components.component';



@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [
        ActionPopupComponent,
        RecordActionComponent,
        SystemActionsComponent,
        SystemActionViewComponent,
        ComponentActionViewComponent,
        CreateMultipleSystemComponentsComponent,
    ],
    providers: [
        ActionService,
    ]
})
  export class ActionModule { }
